// Mixins
import AppPage from '../../mixins/app-page'

// Utils
import getAbsoluteBoundingRect from '../../utils/getAbsoluteBoundingRect'

export default
{
    name: 'page-404',

    mixins:
    [
        AppPage
    ],

    props:
    {

    },

    data()
    {
        return {
            containerHeight: 0
        }
    },

    computed:
    {
        content()
        {
            return this.$root.contentPage.page.acf
        }
    },

    created()
    {
        console.log(this.content)
        // Events
        this.eventHub.$on('app-header:resized', this._onHeaderResized)
        this.eventHub.$on('app-footer:resized', this._onFooterResized)

        // Variables
        this._headerRect = null
        this._footerRect = null
    },

    mounted()
    {
        // Events
        this.eventHub.$emit('page:medias-loaded')
    },

    destroyed()
    {
        // Events
        this.eventHub.$off('app-header:resized', this._onHeaderResized)
        this.eventHub.$off('app-footer:resized', this._onFooterResized)
    },

    methods:
    {
        // Events
        _onHeaderResized()
        {
            this.$header = document.querySelector('.js-header')

            if (this.$header)
            {
                this._headerRect = getAbsoluteBoundingRect(this.$header)

                this._calculateContainerHeight()
            }
        },

        _onFooterResized()
        {
            this.$footer = document.querySelector('.js-footer')

            if (this.$footer)
            {
                this._footerRect = getAbsoluteBoundingRect(this.$footer)

                this._calculateContainerHeight()
            }
        },

        // Actions
        _calculateContainerHeight()
        {
            if (this.$root.width <= this.$root.CONSTANTS.breakpoints.md)
            {
                this.containerHeight = this.$root.height
            }
            else if (this._headerRect
                && this._footerRect)
            {
                this.containerHeight = this.$root.height - this._headerRect.height - this._footerRect.height

                this.eventHub.$emit('page-404:container-mounted')
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/page-404/script.js